export default "__VITE_ASSET__9ec4ed0d__"